import http from './request';

export function uploadFile(file, fn, options = {}) {
  let url = 'blob/blob';

  if (options.url) {
    url = options.url;
  }

  const formData = new FormData();

  formData.append('file', file);

  if (options.otherParams) {
    for (const key in options.otherParams) {
      const val = options.otherParams[key];
      formData.append(key, val);
    }
  }

  const reqParam = {
    url: url,
    method: 'post',
    data: formData,
    headers: Object.assign({
      'Content-Type': 'multipart/form-data;charset=utf-8',
    }),

    onUploadProgress: function (progressEvent) {
      let uploadTask = {};

      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

      uploadTask.progress = percentCompleted;
      uploadTask.totalBytesSent = progressEvent.loaded;
      uploadTask.totalBytesExpectedToSend = progressEvent.total;

      if (fn && typeof fn === 'function') {
        fn(uploadTask);
      }
    },
  };

  return http(reqParam);
}

// ---------------------Admin---------------------

// 管理员登录
export function getAdminLogin(body = {}, query = {}) {
  return http({
    url: '/admin/login',
    method: 'post',
    data: body,
    query: query,
  });
}

// 删除管理员
export function deleteAdmin(body = {}, query = {}) {
  return http({
    url: '/admin',
    method: 'delete',
    data: body,
    query: query,
  });
}

// 获取单个管理员信息
export function getAdmin(body = {}, query = {}) {
  return http({
    url: '/admin',
    method: 'get',
    data: body,
    query: query,
  });
}

// 创建管理员
export function postAdmin(body = {}, query = {}) {
  return http({
    url: '/admin',
    method: 'post',
    data: body,
    query: query,
  });
}

// 修改管理员
export function putAdmin(body = {}, query = {}) {
  return http({
    url: '/admin',
    method: 'put',
    data: body,
    query: query,
  });
}

// 获取管理员列表
export function getAdminList(body = {}, query = {}) {
  return http({
    url: '/admin/list',
    method: 'get',
    data: body,
    query: query,
  });
}

// ---------------------Category---------------------

export function deleteCategory(body = {}, query = {}) {
  return http({
    url: '/category',
    method: 'delete',
    data: body,
    query: query,
  });
}

export function getCategory(body = {}, query = {}) {
  return http({
    url: '/category',
    method: 'get',
    data: body,
    query: query,
  });
}

export function postCategory(body = {}, query = {}) {
  return http({
    url: '/category',
    method: 'post',
    data: body,
    query: query,
  });
}

export function putCategory(body = {}, query = {}) {
  return http({
    url: '/category',
    method: 'put',
    data: body,
    query: query,
  });
}

export function getCategoryList(body = {}, query = {}) {
  return http({
    url: '/category/list',
    method: 'get',
    data: body,
    query: query,
  });
}

// ---------------------Config---------------------

export function deleteConfig(body = {}, query = {}) {
  return http({
    url: '/config',
    method: 'delete',
    data: body,
    query: query,
  });
}

export function getConfig(body = {}, query = {}) {
  return http({
    url: '/config',
    method: 'get',
    data: body,
    query: query,
  });
}

export function postConfig(body = {}, query = {}) {
  return http({
    url: '/config',
    method: 'post',
    data: body,
    query: query,
  });
}

export function putConfig(body = {}, query = {}) {
  return http({
    url: '/config',
    method: 'put',
    data: body,
    query: query,
  });
}

export function getConfigList(body = {}, query = {}) {
  return http({
    url: '/config/list',
    method: 'get',
    data: body,
    query: query,
  });
}

// ---------------------Item---------------------

export function deleteItem(body = {}, query = {}) {
  return http({
    url: '/item',
    method: 'delete',
    data: body,
    query: query,
  });
}

export function getItem(body = {}, query = {}) {
  return http({
    url: '/item',
    method: 'get',
    data: body,
    query: query,
  });
}

export function postItem(body = {}, query = {}) {
  return http({
    url: '/item',
    method: 'post',
    data: body,
    query: query,
  });
}

export function putItem(body = {}, query = {}) {
  return http({
    url: '/item',
    method: 'put',
    data: body,
    query: query,
  });
}

export function putItemRank(body = {}, query = {}) {
  return http({
    url: '/item/rank',
    method: 'put',
    data: body,
    query: query,
  });
}

export function getItemList(body = {}, query = {}) {
  return http({
    url: '/item/list',
    method: 'get',
    data: body,
    query: query,
  });
}

// ---------------------ItemVariation---------------------

export function deleteItemVariation(body = {}, query = {}) {
  return http({
    url: '/itemVariation',
    method: 'delete',
    data: body,
    query: query,
  });
}

export function getItemVariation(body = {}, query = {}) {
  return http({
    url: '/itemVariation',
    method: 'get',
    data: body,
    query: query,
  });
}

export function postItemVariation(body = {}, query = {}) {
  return http({
    url: '/itemVariation',
    method: 'post',
    data: body,
    query: query,
  });
}

export function putItemVariation(body = {}, query = {}) {
  return http({
    url: '/itemVariation',
    method: 'put',
    data: body,
    query: query,
  });
}

export function getItemVariationList(body = {}, query = {}) {
  return http({
    url: '/itemVariation/list',
    method: 'get',
    data: body,
    query: query,
  });
}

// ---------------------MainDisplay---------------------

export function deleteMainDisplay(body = {}, query = {}) {
  return http({
    url: '/mainDisplay',
    method: 'delete',
    data: body,
    query: query,
  });
}

export function getMainDisplay(body = {}, query = {}) {
  return http({
    url: '/mainDisplay',
    method: 'get',
    data: body,
    query: query,
  });
}

export function postMainDisplay(body = {}, query = {}) {
  return http({
    url: '/mainDisplay',
    method: 'post',
    data: body,
    query: query,
  });
}

export function putMainDisplay(body = {}, query = {}) {
  return http({
    url: '/mainDisplay',
    method: 'put',
    data: body,
    query: query,
  });
}

export function getMainDisplayList(body = {}, query = {}) {
  return http({
    url: '/mainDisplay/list',
    method: 'get',
    data: body,
    query: query,
  });
}

// ---------------------Ad---------------------

export function deleteAd(body = {}, query = {}) {
  return http({
    url: '/ad',
    method: 'delete',
    data: body,
    query: query,
  });
}

export function getAd(body = {}, query = {}) {
  return http({
    url: '/ad',
    method: 'get',
    data: body,
    query: query,
  });
}

export function postAd(body = {}, query = {}) {
  return http({
    url: '/ad',
    method: 'post',
    data: body,
    query: query,
  });
}

export function putAd(body = {}, query = {}) {
  return http({
    url: '/ad',
    method: 'put',
    data: body,
    query: query,
  });
}

export function getAdList(body = {}, query = {}) {
  return http({
    url: '/ad/list',
    method: 'get',
    data: body,
    query: query,
  });
}

// ---------------------User---------------------

export function deleteUser(body = {}, query = {}) {
  return http({
    url: '/user',
    method: 'delete',
    data: body,
    query: query,
  });
}

export function getUser(body = {}, query = {}) {
  return http({
    url: '/user',
    method: 'get',
    data: body,
    query: query,
  });
}

export function postUser(body = {}, query = {}) {
  return http({
    url: '/user',
    method: 'post',
    data: body,
    query: query,
  });
}

export function putUser(body = {}, query = {}) {
  return http({
    url: '/user',
    method: 'put',
    data: body,
    query: query,
  });
}

export function getUserList(body = {}, query = {}) {
  return http({
    url: '/user/list',
    method: 'get',
    data: body,
    query: query,
  });
}

// ---------------------Feedback---------------------

export function deleteFeedback(body = {}, query = {}) {
  return http({
    url: '/feedback',
    method: 'delete',
    data: body,
    query: query,
  });
}

export function getFeedback(body = {}, query = {}) {
  return http({
    url: '/feedback',
    method: 'get',
    data: body,
    query: query,
  });
}

export function postFeedback(body = {}, query = {}) {
  return http({
    url: '/feedback',
    method: 'post',
    data: body,
    query: query,
  });
}

export function putFeedback(body = {}, query = {}) {
  return http({
    url: '/feedback',
    method: 'put',
    data: body,
    query: query,
  });
}

export function getFeedbackList(body = {}, query = {}) {
  return http({
    url: '/feedback/list',
    method: 'get',
    data: body,
    query: query,
  });
}

// ---------------------Coupon---------------------

export function deleteCoupon(body = {}, query = {}) {
  return http({
    url: '/coupon',
    method: 'delete',
    data: body,
    query: query,
  });
}

export function getCoupon(body = {}, query = {}) {
  return http({
    url: '/coupon',
    method: 'get',
    data: body,
    query: query,
  });
}

export function postCoupon(body = {}, query = {}) {
  return http({
    url: '/coupon',
    method: 'post',
    data: body,
    query: query,
  });
}

export function putCoupon(body = {}, query = {}) {
  return http({
    url: '/coupon',
    method: 'put',
    data: body,
    query: query,
  });
}

export function getCouponList(body = {}, query = {}) {
  return http({
    url: '/coupon/list',
    method: 'get',
    data: body,
    query: query,
  });
}

// ---------------------OpticalResult---------------------

export function deleteOpticalResult(body = {}, query = {}) {
  return http({
    url: '/opticalResult',
    method: 'delete',
    data: body,
    query: query,
  });
}

export function getOpticalResult(body = {}, query = {}) {
  return http({
    url: '/opticalResult',
    method: 'get',
    data: body,
    query: query,
  });
}

export function postOpticalResult(body = {}, query = {}) {
  return http({
    url: '/opticalResult',
    method: 'post',
    data: body,
    query: query,
  });
}

export function putOpticalResult(body = {}, query = {}) {
  return http({
    url: '/opticalResult',
    method: 'put',
    data: body,
    query: query,
  });
}

export function getOpticalResultList(body = {}, query = {}) {
  return http({
    url: '/opticalResult/list',
    method: 'get',
    data: body,
    query: query,
  });
}

export function getStatsProductViewLogs(body = {}, query = {}) {
  return http({ url: '/stats/productViewLogs', method: 'get', data: body, query });
}

export function getStatsProductViews(body = {}, query = {}) {
  return http({ url: '/stats/productViews', method: 'get', data: body, query });
}

export function getStatsMiniProgramAccessLogs(body = {}, query = {}) {
  return http({ url: '/stats/miniProgramAccessLogs', method: 'get', data: body, query });
}

// 获取当前登录管理员的会话资料，不进入管理员账号管理接口。
export function getCurrentAdmin() {
  return http({
    url: '/backoffice/auth/me',
    method: 'get',
  });
}

export function getOpticalResultUpload(body = {}, query = {}) {
  return http({
    url: '/opticalResult/upload',
    method: 'get',
    data: body,
    query: query,
  });
}

export function getOpticalResultUploadList(body = {}, query = {}) {
  return http({
    url: '/opticalResult/upload/list',
    method: 'get',
    data: body,
    query: query,
  });
}

export function putOpticalResultUploadVoid(body = {}, query = {}) {
  return http({
    url: '/opticalResult/upload/void',
    method: 'put',
    data: body,
    query: query,
  });
}

export function postOpticalResultUploadReview(body = {}, query = {}) {
  return http({
    url: '/opticalResult/upload/review',
    method: 'post',
    data: body,
    query: query,
  });
}

// ---------------------Stats---------------------

export function getStatSuserRegisterTotal(body = {}, query = {}) {
  return http({
    url: '/stats/userRegisterTotal',
    method: 'get',
    data: body,
    query: query,
  });
}

export function getStatsOrderTotal(body = {}, query = {}) {
  return http({
    url: '/stats/orderTotal',
    method: 'get',
    data: body,
    query: query,
  });
}

export function getStatsPaymentCount(body = {}, query = {}) {
  return http({
    url: '/stats/paymentCount',
    method: 'get',
    data: body,
    query: query,
  });
}

export function getStatsWishAddCount(body = {}, query = {}) {
  return http({
    url: '/stats/wishAddCount',
    method: 'get',
    data: body,
    query: query,
  });
}

export function getStatsItemSaleCount(body = {}, query = {}) {
  return http({
    url: '/stats/itemSaleCount',
    method: 'get',
    data: body,
    query: query,
  });
}

export function getStatsSalesProblemCount(body = {}, query = {}) {
  return http({
    url: '/stats/salesProblemCount',
    method: 'get',
    data: body,
    query: query,
  });
}

export function getStatsSearchCount(body = {}, query = {}) {
  return http({
    url: '/stats/searchCount',
    method: 'get',
    data: body,
    query: query,
  });
}

export function getStatsTryOn(body = {}, query = {}) {
  return http({
    url: '/stats/tryOn',
    method: 'get',
    data: body,
    query: query,
  });
}

// ---------------------OrderedItem---------------------

export function deleteOrderedItem(body = {}, query = {}) {
  return http({
    url: '/orderedItem',
    method: 'delete',
    data: body,
    query: query,
  });
}

export function getOrderedItem(body = {}, query = {}) {
  return http({
    url: '/orderedItem',
    method: 'get',
    data: body,
    query: query,
  });
}

export function postOrderedItem(body = {}, query = {}) {
  return http({
    url: '/orderedItem',
    method: 'post',
    data: body,
    query: query,
  });
}

export function putOrderedItem(body = {}, query = {}) {
  return http({
    url: '/orderedItem',
    method: 'put',
    data: body,
    query: query,
  });
}

export function getOrderedItemList(body = {}, query = {}) {
  return http({
    url: '/orderedItem/list',
    method: 'get',
    data: body,
    query: query,
  });
}

export function putOrderedItemStatus(body = {}, query = {}) {
  return http({
    url: '/orderedItem/status',
    method: 'put',
    data: body,
    query: query,
  });
}

// ---------------------Order---------------------

export function deleteOrder(body = {}, query = {}) {
  return http({
    url: '/order',
    method: 'delete',
    data: body,
    query: query,
  });
}

export function getOrder(body = {}, query = {}) {
  return http({
    url: '/order',
    method: 'get',
    data: body,
    query: query,
  });
}

export function getOrderStatusCount(body = {}, query = {}) {
  return http({
    url: '/order/statusCount',
    method: 'get',
    data: body,
    query: query,
  });
}

export function postOrder(body = {}, query = {}) {
  return http({
    url: '/order',
    method: 'post',
    data: body,
    query: query,
  });
}

export function putOrder(body = {}, query = {}) {
  return http({
    url: '/order',
    method: 'put',
    data: body,
    query: query,
  });
}

export function getOrderList(body = {}, query = {}) {
  return http({
    url: '/order/list',
    method: 'get',
    data: body,
    query: query,
  });
}

export function putOrderStatus(body = {}, query = {}) {
  return http({
    url: '/order/status',
    method: 'put',
    data: body,
    query: query,
  });
}

// ---------------------Info---------------------

export function postInfoDeliveryIds(body = {}, query = {}) {
  return http({
    url: '/info/deliveryIds',
    method: 'post',
    data: body,
    query: query,
  });
}

// 新功能分割
// 新功能分割
// 新功能分割
// 新功能分割
// 新功能分割
// 新功能分割
// 新功能分割
// 新功能分割
// 新功能分割
// 新功能分割
// 新功能分割
// 新功能分割
// 新功能分割
// 新功能分割
// 新功能分割
// 新功能分割
// 新功能分割
// 新功能分割
// 新功能分割
// 新功能分割
// 新功能分割
// 新功能分割
// 新功能分割
// 新功能分割
// 新功能分割
// 新功能分割

// ---------------------TryOnOrder---------------------

export function deleteTryOnOrder(body = {}, query = {}) {
  return http({
    url: '/tryonorder',
    method: 'delete',
    data: body,
    query: query,
  });
}

export function getTryOnOrder(body = {}, query = {}) {
  return http({
    url: '/tryonorder',
    method: 'get',
    data: body,
    query: query,
  });
}

export function postTryOnOrder(body = {}, query = {}) {
  return http({
    url: '/tryonorder',
    method: 'post',
    data: body,
    query: query,
  });
}

export function putTryOnOrder(body = {}, query = {}) {
  return http({
    url: '/tryonorder',
    method: 'put',
    data: body,
    query: query,
  });
}

export function putTryOnOrderReturnStatus(body = {}, query = {}) {
  return http({
    url: '/tryonorder/returnStatus',
    method: 'put',
    data: body,
    query: query,
  });
}

export function getTryOnOrderList(body = {}, query = {}) {
  return http({
    url: '/tryonorder/list',
    method: 'get',
    data: body,
    query: query,
  });
}

export function putTryOnOrderStatus(body = {}, query = {}) {
  return http({
    url: '/tryonorder/status',
    method: 'put',
    data: body,
    query: query,
  });
}

// ---------------------TryOnOrderedItem---------------------

export function deleteTryOnOrderedItem(body = {}, query = {}) {
  return http({
    url: '/tryonordereditem',
    method: 'delete',
    data: body,
    query: query,
  });
}

export function getTryOnOrderedItem(body = {}, query = {}) {
  return http({
    url: '/tryonordereditem',
    method: 'get',
    data: body,
    query: query,
  });
}

export function postTryOnOrderedItem(body = {}, query = {}) {
  return http({
    url: '/tryonordereditem',
    method: 'post',
    data: body,
    query: query,
  });
}

export function putTryOnOrderedItem(body = {}, query = {}) {
  return http({
    url: '/tryonordereditem',
    method: 'put',
    data: body,
    query: query,
  });
}

export function getTryOnOrderedItemList(body = {}, query = {}) {
  return http({
    url: '/tryonordereditem/list',
    method: 'get',
    data: body,
    query: query,
  });
}

// Explicit commands replace arbitrary order status writes.
export function postOrderAdminCancel(id, body = {}) {
  return http({ url: `/order/${id}/admin-cancel`, method: 'post', data: body });
}

export function postOrderShip(id, body = {}) {
  return http({ url: `/order/${id}/ship`, method: 'post', data: body });
}

export function postOrderMarkDelivered(id, body = {}) {
  return http({ url: `/order/${id}/mark-delivered`, method: 'post', data: body });
}

export function postOrderMarkCompleted(id, body = {}) {
  return http({ url: `/order/${id}/mark-completed`, method: 'post', data: body });
}

// Backoffice logistics remains separate from the unauthenticated mini-program compatibility endpoint.
export function getBackofficeOrderLogistics(id) {
  return http({ url: `/order/${id}/backoffice-logistics`, method: 'get' });
}

export function postOrderedItemAdminCancel(id, body = {}) {
  return http({ url: `/ordered-item/${id}/cancel`, method: 'post', data: body });
}

export function postOrderedItemRefund(id, body = {}) {
  return http({ url: `/ordered-item/${id}/refund`, method: 'post', data: body });
}

export function postOrderedItemRejectAfterSale(id, body = {}) {
  return http({ url: `/ordered-item/${id}/reject-after-sale`, method: 'post', data: body });
}

// ---------------------WeComMember---------------------

export function getWeComMemberList(body = {}, query = {}) {
  return http({
    url: '/wecom/member/list',
    method: 'get',
    data: body,
    query: query,
  });
}

export function postWeComMember(body = {}, query = {}) {
  return http({
    url: '/wecom/member',
    method: 'post',
    data: body,
    query: query,
  });
}

export function putWeComMember(body = {}, query = {}) {
  return http({
    url: '/wecom/member',
    method: 'put',
    data: body,
    query: query,
  });
}

export function postWeComMemberSync(body = {}, query = {}) {
  return http({
    url: '/wecom/member/sync',
    method: 'post',
    data: body,
    query: query,
  });
}

// ---------------------Notification---------------------

export function getNotificationRuleList(body = {}, query = {}) {
  return http({
    url: '/notification/rule/list',
    method: 'get',
    data: body,
    query: query,
  });
}

export function getNotificationRule(body = {}, query = {}) {
  return http({
    url: '/notification/rule',
    method: 'get',
    data: body,
    query: query,
  });
}

export function postNotificationRule(body = {}, query = {}) {
  return http({
    url: '/notification/rule',
    method: 'post',
    data: body,
    query: query,
  });
}

export function putNotificationRule(body = {}, query = {}) {
  return http({
    url: '/notification/rule',
    method: 'put',
    data: body,
    query: query,
  });
}

export function deleteNotificationRule(body = {}, query = {}) {
  return http({
    url: '/notification/rule',
    method: 'delete',
    data: body,
    query: query,
  });
}

export function getNotificationEventList(body = {}, query = {}) {
  return http({
    url: '/notification/event/list',
    method: 'get',
    data: body,
    query: query,
  });
}

export function getNotificationDeliveryList(body = {}, query = {}) {
  return http({
    url: '/notification/delivery/list',
    method: 'get',
    data: body,
    query: query,
  });
}

// ---------------------ActivityNotification---------------------

export function getActivityNotificationOverview(body = {}, query = {}) {
  return http({ url: '/activityNotification/overview', method: 'get', data: body, query });
}
export function getActivityNotificationActivities(body = {}, query = {}) {
  return http({ url: '/activityNotification/activities', method: 'get', data: body, query });
}
export function getActivityNotificationActivity(id) {
  return http({ url: `/activityNotification/activities/${id}`, method: 'get' });
}
export function postActivityNotificationActivity(body = {}) {
  return http({ url: '/activityNotification/activities', method: 'post', data: body });
}
export function putActivityNotificationActivity(id, body = {}) {
  return http({ url: `/activityNotification/activities/${id}`, method: 'put', data: body });
}
export function postActivityNotificationEnable(id) {
  return http({ url: `/activityNotification/activities/${id}/enable`, method: 'post', data: {} });
}
export function postActivityNotificationCancel(id, body = {}) {
  return http({ url: `/activityNotification/activities/${id}/cancel`, method: 'post', data: body });
}
export function deleteActivityNotificationDraft(id) {
  return http({ url: `/activityNotification/activities/${id}`, method: 'delete' });
}
export function postActivityNotificationStart(id) {
  return http({ url: `/activityNotification/activities/${id}/start`, method: 'post', data: {} });
}
export function postActivityNotificationStop(id, body = {}) {
  return http({ url: `/activityNotification/activities/${id}/stop`, method: 'post', data: body });
}
export function getActivitySubscriptionTemplates(body = {}, query = {}) {
  return http({ url: '/activityNotification/subscription-templates', method: 'get', data: body, query });
}
export function getActivitySubscriptionIdentities(body = {}, query = {}) {
  return http({ url: '/activityNotification/subscription-identities', method: 'get', data: body, query });
}
export function getActivitySubscriptionLedger(body = {}, query = {}) {
  return http({ url: '/activityNotification/subscription-ledger', method: 'get', data: body, query });
}
export function exportActivitySubscriptionIdentities(body = {}, query = {}) {
  return http({ url: '/activityNotification/subscription-identities/export', method: 'get', data: body, query });
}
export function getActivityNotificationBatches(body = {}, query = {}) {
  return http({ url: '/activityNotification/batches', method: 'get', data: body, query });
}
export function exportActivityNotificationBatches() {
  return http({ url: '/activityNotification/batches/export', method: 'get' });
}
export function getActivityNotificationRecipients(batchId, body = {}, query = {}) {
  return http({ url: `/activityNotification/batches/${batchId}/recipients`, method: 'get', data: body, query });
}

export function getActivityOrderNotifications(body = {}, query = {}) {
  return http({ url: '/activityNotification/order-notifications', method: 'get', data: body, query });
}

export function getActivityOrderNotification(id) {
  return http({ url: `/activityNotification/order-notifications/${id}`, method: 'get' });
}
export function getActivityMessageSendRecords(body = {}, query = {}) {
  return http({ url: '/activityNotification/message-send-records', method: 'get', data: body, query });
}
export function exportActivityNotificationRecipients(batchId) {
  return http({ url: `/activityNotification/batches/${batchId}/recipients/export`, method: 'get' });
}
